import { StatusType } from '../enums';

export class ToasterModel {
	message: string;
	type: StatusType;
	date: Date;
	countMessage: boolean;
	remainingMinutes: number;
}
